import React from 'react';

import { IconButton } from 'e100-react-components';

import { useStyles } from './styles';

export const DatePickerClearButton = ({
  onClick,
  show
}: DatePickerClearButtonProps) => {
  const classes = useStyles();

  if (!show) {
    return null;
  }

  return (
    <IconButton
      kind={'close'}
      onClick={onClick}
      classes={{
        button: {
          root: classes.iconButton
        },
        icon: {
          root: classes.icon
        }
      }}
    />
  );
};

interface DatePickerClearButtonProps {
  show?: boolean;
  onClick: () => void;
}
